module.exports = __webpack_public_path__ + "static/media/double.63586b1e.JPG";